import React, {FC} from "react";
import {Fade, IconButton, Popper, SxProps, Theme, Typography} from "@mui/material";
import {getStoreUtils} from "../../store/utils";
import {clearImageShape, restartPackage, setEditShapeModalState, setIsEditMode} from "../../ducks/montitoring";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import {RowContainer, ShapeModePopper, SubRowContainer} from "./shape-mode-button-styles";
import {useSelector} from "react-redux";
import {selectImageShapes} from "../../selectors/monitoring";
import {PageParts} from "../../ducks/types";
import { ReactComponent as CancelIcon } from './cut.svg';

const iconSx = {
    width: '40px',
    height: '40px',
    color: '#000'
};

const popupIconSx: SxProps<Theme> = {
    width: '24px',
    height: '24px',
    backgroundColor: '#FFF !important',
}


export const ShapeModeButton: FC = () => {
    const {dispatch} = getStoreUtils();

    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const [open, setOpen] = React.useState(false);

    const imageShapes = useSelector(selectImageShapes);
    const isRestartPairButtonDisabled = !imageShapes || (imageShapes && (!imageShapes[PageParts.Left] && !imageShapes[PageParts.Right]));

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        setOpen((prev) => !prev);
        dispatch(setIsEditMode(!open));
    };

    const handleClose = () => {
        setAnchorEl(null);
        setOpen((prev) => !prev);
        dispatch(setIsEditMode(false));
        dispatch(setEditShapeModalState());
        dispatch(clearImageShape());
    }

    const onRestart = () => {
        dispatch(restartPackage());
    }

    return <>
        <IconButton
            title={'Режим обрезки'}
            onClick={handleClick}
            sx={iconSx}
        >
            <CancelIcon/>
        </IconButton>
        <ShapeModePopper
            open={open}
            anchorEl={anchorEl}
            placement={'right'}
            transition
        >
            {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={350}>
                    <RowContainer>
                        <Typography sx={{ p: 1 }}>Кликните на страницу для обрезки</Typography>
                        <SubRowContainer>
                            <IconButton
                                disabled={isRestartPairButtonDisabled}
                                size={'small'}
                                sx={{
                                    ...popupIconSx, color: 'green'
                                }}
                                onClick={onRestart}
                            >
                                <CheckIcon/>
                            </IconButton>
                            <IconButton
                                onClick={handleClose}
                                size={'small'}
                                sx={{
                                    ...popupIconSx, color: 'red'
                                }}
                            >
                                <CloseIcon/>
                            </IconButton>
                        </SubRowContainer>
                    </RowContainer>
                </Fade>
            )}
        </ShapeModePopper>
    </>
}
